<template>
  <div>
    <v-dialog v-model="show" persistent width="640">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Movimento Duplicado
        </v-card-title>

        <v-card-text>
          <div v-html="message"></div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="close"> Fechar </v-btn>
          <v-btn color="primary" text @click="overwrite">
            Sobrescrever Movimento
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ModalMovimentoDuplicado",
  props: {
    show: Boolean,
    message: String
  },
  methods: {
    close() {
      this.$emit("close");
    },
    overwrite() {
      this.$emit("overwrite");
    }
  }
};
</script>
